import styled from "styled-components";
import Container from "react-bootstrap/Container";
import { Link } from "react-scroll";

export const Wrapper = styled.header`
  border-bottom: 1px solid #fafafa;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(146, 161, 176, 0.15);
  padding: 15px 0 5px 0;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  font-weight: 600;
  @media (max-width: 786px) {
    padding: 10px 0 10px 10px;
    height: 3rem;
  }
`;

export const ColorText = styled.span`
  color: ${({ color }) => color};
`;

export const NavBarContainer = styled(Container)`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export const NavBarTitle = styled(Link)`
  display: inline;
  justify-content: flex-start;
  font-size: 1.2rem;
  @media screen and (min-width: 786px) {
    font-size: 1.3rem;
  }
  cursor: pointer;
  color: #0e2431;
  &:hover {
    text-decoration: none;
    color: #0e2431;
  }
`;

export const NavBarMenu = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: none;
  @media (max-width: 786px) {
    display: block;
  }
`;

export const NavBarBody = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: 786px) {
    display: none;
  }
`;

export const NavBarLink = styled(Link)`
  color: #0e2431;
  cursor: pointer;
  font-size: 16px;
  ${({ active, color }) => active && `border-bottom: 2px solid ${color}`};
  margin: 5px 23px;
  padding-bottom: 8px;
  &:hover {
    color: #0e2431;
    text-decoration: none;
    border-bottom: 2px solid ${({ color }) => color};
  }
  &.last {
    margin-right: 0;
  }
`;
